export const API = {
    url: "https://api.superights.net/",
    base: "api/v1/front",
    baseServer: "api/v1"

};